module.exports = __webpack_public_path__ + "static/media/gpay.9b6161fd.svg";